import * as yup from "yup";

export const formSchema = yup.object({
  email: yup.string().email().required().min(5),
  consent: yup.boolean().oneOf([true]).required(),
});
